import styled from '@emotion/styled'

export const OptionListItem = styled.li`
	&.MuiAutocomplete-option {
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		margin: 3px;

		&[aria-selected='true'] {
			background: ${({ theme }) => theme.palette.backgroundColors.lighterGrey};
		}
	}
`
